// removed by extract-text-webpack-plugin
module.exports = {"content":"terms__content-3HL56 blocks__content--MOaB","title":"terms__title-3VZXn","link":"terms__link-Debjz"};


//////////////////
// WEBPACK FOOTER
// ./components/terms/terms.css
// module id = 853
// module chunks = 0